export default class Navigation {
	constructor() {
		// Nav Menu Triggers
		this.nav_links = document.getElementsByClassName( 'nav-link' );

		//Nav Menu Types
		this.nav_link_types = [];

		for ( let nav_link of this.nav_links ) {
			this.nav_link_types.push( nav_link.classList[ nav_link.classList.length -1 ] );
		}

		// Menus
		this.nav_menus = document.getElementsByClassName( 'nav-menu' );
	}
};

export class ToggleMenuClass extends Navigation {
	constructor() {
		super();

		// Bind the toggle function
		this.toggleMenuClass = this.toggleMenuClass.bind( this );

		// On click, show or hide the menu
		for ( let nav_link of this.nav_links ) {
			nav_link.addEventListener( 'click', e => this.toggleMenuClass( e ) );
		}
	}

	// Menu Toggle
	toggleMenuClass( e ) {
		for ( let nav_link_type of this.nav_link_types ) {
			if ( e.target.classList.contains( nav_link_type ) ) {
				for ( let nav_menu of this.nav_menus ) {
					if ( nav_menu.classList.contains ( nav_link_type ) ) {
						e.target.classList.toggle( 'active' );
						nav_menu.classList.toggle( 'active' );
					}
				}
			}
		}
	};
};
new ToggleMenuClass();


// WEBPACK FOOTER //
// ./js/modules/Navigation.js